import { render, staticRenderFns } from "./DesktopSideMenuItem.vue?vue&type=template&id=1d0dc763&scoped=true&"
import script from "./DesktopSideMenuItem.vue?vue&type=script&lang=js&"
export * from "./DesktopSideMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./DesktopSideMenuItem.vue?vue&type=style&index=0&id=1d0dc763&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0dc763",
  null
  
)

export default component.exports